module.exports = __webpack_public_path__ + "img/sound-effect-pause.11c9ea1b.svg";